var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.login}},[_vm._v("\n    Hello\n  ")]),_c('div',[_vm._v("\n    "+_vm._s(_vm.token)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }